// extracted by mini-css-extract-plugin
export default {"buttons":"ReceivablePaymentComponent_buttons__LyIpZ","total":"ReceivablePaymentComponent_total__QCth-"};